import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, map } from 'rxjs';
import { API_ENDPOINTS } from '../../constants/api-endpoints.constant';
import { DevoteeService } from './devotee.service';

const BASE_URL = environment.apiBaseUrl;
const DP_API_URL_V1 = environment.dpApiBaseUrlV1;
const DP_API_URL_V2 = environment.dpApiBaseUrlV2;

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(
    private http: HttpClient,
    private _devoteeService: DevoteeService
  ) { }

  fetchUserDetails(): Observable<any> {
    const url = `${BASE_URL}${API_ENDPOINTS.USERS}`;

    return this.http.get<any>(url);
  }

  fetchGuestUser(): Observable<any>{
    return this.http.get(`${BASE_URL}${API_ENDPOINTS.GUEST_USERS}`)
  }

  // fetchUserDetails(): Observable<any> {
  //   const url = `${BASE_URL}${API_ENDPOINTS.USERS}`;
  //   return this.http.get<any>(url);
  // }

  // Implement below code when API is available

  getUserStatus(): Observable<boolean> {
    const url = `underimplementation`;
    // API call to get user status
    return this.http.get<boolean>(url);
  }

  setUserStatus(isAvailable: boolean): Observable<any> {
    const url = `underimplementation`;
    // API call to set user status
    return this.http.post(url, { isAvailable });
  }

  getPINInfo(pincode: any): Observable<any> {
    const url = `${BASE_URL}${API_ENDPOINTS.PINCODE}${pincode}`;
    return this.http.get<any>(url);
  }

  getRitwiks(name: string): Observable<any> {
    const url = `${BASE_URL}${API_ENDPOINTS.RITWIKS}`;
    return this.http.get<any>(`${url}?name=${name}`);
  }

  createUser(payload: any): Observable<any> {
    const url = `${BASE_URL}${API_ENDPOINTS.USERS}`;
    return this.http.post<any>(url, payload);
  }

   updateUser(id: any, payload: any): Observable<any> {
    const url = `${BASE_URL}${API_ENDPOINTS.USERS}/${id}`;
    return this.http.patch<any>(url, payload);
  }

  removeUser(id: any): Observable<any> {
    const url = `${BASE_URL}${API_ENDPOINTS.USERS}/${id}`;
    return this.http.delete<any>(url);
  }

  getAllRoles(): Observable<any> {
    const url = `${BASE_URL}${API_ENDPOINTS.USERS}/attributes`
    return this.http.get<any>(url);
  }
}


